import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css';

function MainLayout({ children, onLogout }) {
  const location = useLocation();

  return (
    <div className="admin-layout">
      <Sidebar currentPath={location.pathname} />
      <div className="admin-main">
        <Header onLogout={onLogout} />
        {children}
      </div>
    </div>
  );
}

export default MainLayout;






